
import { FaCheckCircle, FaLightbulb, FaHandshake, FaLeaf } from 'react-icons/fa';

export default function CompanyValues() {
  // Using react-icons library for better icon quality

  const values = [
    {
      icon: FaCheckCircle,
      title: 'Quality First',
      description: 'Every piece we make meets international standards with rigorous quality control processes.'
    },
    {
      icon: FaLightbulb,
      title: 'Innovation',
      description: 'From leather finishing to new materials, we constantly push boundaries in manufacturing.'
    },
    {
      icon: FaHandshake,
      title: 'Partnership',
      description: 'We believe in building long-term trust and relationships with every client.'
    },
    {
      icon: FaLeaf,
      title: 'Sustainability',
      description: 'Certified and responsible supply chain with global compliance standards.'
    }
  ];

  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 lg:mb-20">
          <div className="text-gray-600 text-sm font-light tracking-[0.2em] uppercase mb-6">
            Our Foundation
          </div>
          <h2 className="text-5xl lg:text-7xl font-light mb-8 leading-tight">
            What We{' '}
            <span className="font-normal">
              Stand For
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-light leading-relaxed">
            Our core values drive everything we do, from product development to client relationships
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {values.map((value, index) => (
            <div key={index} className="group text-center flex flex-col">
              <div className="bg-gray-100 rounded-xl p-8 hover:bg-gray-200 transition-all duration-300 flex-1 flex flex-col">
                {/* Icon container with consistent sizing */}
                <div className="flex-shrink-0 mb-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-gray-800 to-black rounded-xl flex items-center justify-center mx-auto group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <value.icon className="text-white text-2xl" />
                  </div>
                </div>

                {/* Title - fixed height container */}
                <div className="flex-shrink-0 mb-2">
                  <h3 className="text-lg font-semibold text-gray-900 tracking-wide">{value.title}</h3>
                </div>

                {/* Description - flexible container with minimum height */}
                <div className="flex-1">
                  <p className="text-gray-600 leading-relaxed font-light text-sm">{value.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
